module.exports = __webpack_public_path__ + "static/media/almi.09640e74.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/images/Logos_Lieferanten/almi.png
// module id = 173
// module chunks = 0